const ContractSVG = () => {
  return (
    <svg
      width="90%"
      height="90%"
      viewBox="-20 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M182.99 146.2h585.14v402.28h73.15V73.06H109.85v877.71h402.16v-73.14H182.99z"
        className="fill-neutralLight"
      />
      <path
        d="M256.13 219.34h438.86v73.14H256.13zM256.13 365.63h365.71v73.14H256.13zM256.13 511.91h219.43v73.14H256.13zM731.56 585.06c-100.99 0-182.86 81.87-182.86 182.86s81.87 182.86 182.86 182.86c100.99 0 182.86-81.87 182.86-182.86s-81.87-182.86-182.86-182.86z m0 292.57c-60.5 0-109.71-49.22-109.71-109.71 0-60.5 49.22-109.71 109.71-109.71 60.5 0 109.71 49.22 109.71 109.71 0 60.49-49.22 109.71-109.71 109.71z"
        className="fill-neutralLight"
      />
      <path
        d="M754.16 744.17l-22.6-45.74-22.61 45.74-50.54 7.34 36.58 35.61-8.64 50.28 45.21-23.74 45.2 23.74-8.63-50.28 36.57-35.61z"
        className="fill-neutralLight"
      />
    </svg>
  );
};

export default ContractSVG;
